import AnalysisCollection from "@/collections/lab/AnalysisCollection";
import AnalyteResultCollection from "@/collections/lab/AnalyteResultCollection";
import TestPackageAnalyteCollection from "@/collections/lab/TestPackageAnalyteCollection";
import LabServiceModel from "@/models/LabServiceModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";

export default class AnalyteModel extends LabServiceModel {

  modelName() {
    return 'analyte';
  }

  icon() {
    return 'eye-dropper';
  }

  defaults() {
    return {
      id: null,
      sample_type_id: null,
      sample_type: null,
      name: null,
      abbrev: null,
      modus_name: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      analyses: null,
      //
      range_min: null,
      range_max: null,
      range_unit_id: null,
    }
  }

  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      abbrev: (val) => (this.nullStringMutator(val)),
      modus_name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
      //
      range_min: (val) => this.nullNumberMutator(val),
      range_max: (val) => this.nullNumberMutator(val),
      range_unit_id: (val) => this.nullStringMutator(val),
    }
  }

  validation() {
    return {}
  }

  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }

  getAnalyses() {
    return this.getRelatedCollection(new AnalysisCollection(), 'analyses');
  }

  getTestPackageAnalytes() {
    return this.getRelatedCollection(new TestPackageAnalyteCollection(), 'test_package_analytes');
  }

  getAnalyteResults() {
    return this.getRelatedCollection(new AnalyteResultCollection(), 'analyte_results');
  }

}
